import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/crm/components/AdvisorProfileBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/crm/components/AdvisorView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/crm/components/CollapsibleLeadsView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/crm/components/LeadsView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/crm/components/LeadsViewA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/crm/components/OpportunitiesView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/crm/components/OpportunitiesViewB.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/crm/components/OpportunitiesViewEZ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/crm/components/ReturningInvestorWizard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AcknowledgmentClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LineChartDemo"] */ "/vercel/path0/components/tremor/LineChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/home.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
